import { ChangeDetectionStrategy, Component, QueryList, ViewChildren } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { PanelModule } from 'src/app/shared-ui/panel/panel.module';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { DocumentsStore, XotaMode } from '@store';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-xota-card',
  templateUrl: './xota-card.component.html',
  styleUrls: ['./xota-card.component.scss'],
  standalone: true,
  imports: [
    CommonStandaloneModule,
    PanelModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XotaCardComponent {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  readonly XotaMode = XotaMode;
  readonly xotaAgreementStatus$ = this.documentsStore.xotaAgreementStatus$;
  readonly xotaAgreementLoading$ = this.documentsStore.xotaAgreementLoading$;

  constructor(private documentsStore: DocumentsStore) {}
}
